import React from "react";
import { CLIENT_STAMPS } from "../data/content";

export default function TrustMarquee() {
  const track = [...CLIENT_STAMPS, ...CLIENT_STAMPS];
  return (
    <section
      className="relative py-10 border-y border-[var(--vw-border)] bg-[var(--vw-bg-soft)] overflow-hidden"
      data-testid="vw-trust"
    >
      <div className="vw-container">
        <div className="flex items-center gap-6">
          <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)] hidden md:inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-[var(--vw-cyan)] vw-blink" />
            TRUSTED ACROSS
          </span>
          <div className="relative flex-1 overflow-hidden mask-fade">
            <div className="flex gap-16 vw-marquee-track whitespace-nowrap">
              {track.map((s, i) => (
                <span
                  key={i}
                  className="font-display text-lg md:text-xl uppercase tracking-[0.12em] text-[var(--vw-text-dim)]"
                >
                  {s}
                  <span className="text-[var(--vw-cyan)] mx-8">◆</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .mask-fade {
          mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);
        }
      `}</style>
    </section>
  );
}
